module.exports = __webpack_public_path__ + "static/media/wisetek.a9e1f0a5.png";